import { SketchObjectType } from '../sketch-object';
import { type LibItem } from './common';

export const door: LibItem = {
  id: Math.random() * 100000,
  thumbUrl: '/assets/images/sketch-tool/door.svg',
  name: 'Door',
  type: SketchObjectType.Image,
  src: '/assets/images/sketch-tool/door.svg',
  width: 48,
  height: 48,
};
